import { FC } from 'react';
// Models
import IPage from 'models/Page';
// Components
import Accordion from 'components/Accordion';
import AdditionalQuestionsForm from './AdditionalQuestionsForm';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  page: IPage;
  defaultExpanded?: boolean;
}

const AdditionalQuestions: FC<Props> = ({ page, defaultExpanded }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Accordion
        label={t('labels.additionalQuestion')} icon="help"
        previewPage="additionalQuestions" previewPageRef={page.uuid}
        defaultExpanded={defaultExpanded}
      >
        <AdditionalQuestionsForm page={page} />
      </Accordion>
    </div>
  );
};

export default AdditionalQuestions;
